export function toTwoDigitsNumber(number) {
  return number <= 9 ? "0" + number : String(number);
}
export function convertMSToMMSS(durationMilliseconds) {
  return convertSSToMMSS(durationMilliseconds / 1000);
}
export function convertSSToMMSS(durationSec) {
  var _durationSec;
  durationSec = Math.floor((_durationSec = durationSec) != null ? _durationSec : 0);
  const chunks = [];
  do {
    chunks.unshift(toTwoDigitsNumber(durationSec % 60));
    durationSec = Math.floor(durationSec / 60);
  } while (durationSec > 0);
  if (chunks.length < 2) {
    chunks.unshift('00');
  }
  return chunks.join(':');
}
export function convertMMSSToSS(duration) {
  if (!duration) {
    return 0;
  }
  return duration.split(':').reverse().reduce((acc, chunk, i) => {
    return acc + Number(chunk) * Math.pow(60, i);
  }, 0);
}
export function convertISO8601ToSS(durationStr) {
  return durationStr ? convertMMSSToSS(convertISO8601ToMMSS(durationStr)) : 0;
}
export function convertISO8601ToMMSS(durationStr) {
  if (!durationStr) {
    return '00:00';
  }
  const [, ...parts] = durationStr.match(/^P(?:(\d+)D)?T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/) || [];
  const numParts = parts.map(part => Number(part) || 0);
  const [numDays, numHours, numMinutes, numSeconds] = numParts;
  const [hours, minutes, seconds] = [numDays * 24 + numHours, numMinutes, numSeconds].map(toTwoDigitsNumber);
  if (hours === '00') {
    return minutes + ":" + seconds;
  }
  return hours + ":" + minutes + ":" + seconds;
}
//# sourceMappingURL=time.js.map